import { authActions } from './actions';

const authInitState = {
  user: null,
  loading: false,
  error: null,
};

export function authReducer(state = authInitState, { type, payload }) {
  switch (type) {
    case authActions.WHO_AM_I:
      return {
        ...state,
        loading: true,
      };
    case authActions.WHO_AM_I_SUCCESS:
      return {
        ...state,
        user: payload.data,
        loading: false,
      };
    case authActions.WHO_AM_I_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    case authActions.LOGOUT:
      return {
        ...state,
        user: null,
      };

    default:
      return state;
  }
}
